import React from 'react';
import PropTypes from 'prop-types';
import Icon, { GLYPHS } from '../../../common/icon';

const Header = ({ title, hideClose, onClose }) => (
  <div>
    <div className="o-flexbox u-ph- u-pt--">
      <div className="o-flexbox__item">
        <div className="c-heading c-heading--large c-heading--light">{title}</div>
      </div>
      <div className="o-flexbox__item">
        <a
          data-remodal-action="close"
          className="remodal-close"
          display-if={!hideClose}
          onClick={onClose}
        >
          <Icon glyph={GLYPHS.arrowXClose} size="medium" />
        </a>
      </div>
    </div>
    <div className="c-separator u-m--" />
  </div>
);

Header.propTypes = {
  title: PropTypes.string,
  hideClose: PropTypes.bool,
  onClose: PropTypes.func,
};

Header.defaultProps = {
  title: 'Appointments Details',
  hideClose: false,
  onClose: () => null,
};

export default Header;
